import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { FETCH_SUPER_ADMINS } from '../data/adminsDao';
function toAdminOption(user) {
  const fullName = `${user.firstName} ${user.lastName}`.trim();
  return {
    userId: String(user.id),
    name: fullName.length > 0 ? fullName : user.email,
    email: user.email
  };
}
export function useAdmins() {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_SUPER_ADMINS);
  const admins = useMemo(() => {
    var _data$accessCheckLibH;
    return ((_data$accessCheckLibH = data === null || data === void 0 ? void 0 : data.accessCheckLibHubSuperAdmins) !== null && _data$accessCheckLibH !== void 0 ? _data$accessCheckLibH : []).map(toAdminOption);
  }, [data]);
  return {
    admins,
    isLoading: loading,
    hasError: Boolean(error)
  };
}